import React from "react"

import FieldFormElementView from "../../../../../../render/form-elemnent-view"
import FieldPopover_FormComponent from "../../../../../popover/components/form/form-component"
import FieldPopover_InlineEditable from "../../../../../popover/render/inline-editable"
import FieldTimeSpent_Picker from "../../../render/picker"
import FieldTimeReported_AddFromPopover from "../../../render/my-time/add-from-popover"

const debug = false
// const debug = 'StartEndTime'

type Props = {
    onSubmit?   : callback,
    model       : any,
    parent      : FieldTimeSpent_Picker | FieldPopover_FormComponent | FieldPopover_InlineEditable | FieldTimeReported_AddFromPopover
}

export default function StartEndTime(props:Props) {

    const onStartTimeChange = (value: Moment) => {
        debug && console.log(debug, 'onStartTimeChange', value)

        const picker = props.parent as FieldTimeSpent_Picker
        picker.onTimeChange(value)
    }

    const onEndTimeChange = (value: Moment) => {
        debug && console.log(debug, 'onEndTimeChange', value)

        const picker = props.parent as FieldTimeSpent_Picker
        picker.onTimeChange(undefined, value)
    }

    return (
        <>
            <div className="ui5-txt-no-accent-tiny flex-row-left-center h-30 m-t-10">Start/end</div>
            <div className=" flex-column-left-top">
                <div className="flex-row-left-center w-100-percent">
                    <FieldFormElementView className = "h-36 flex-1"
                                          field     = {gd.fields.timeReport.startMoment}
                                          model     = {props.model}
                                          onChange  = {onStartTimeChange}/>
                    <FieldFormElementView className = "h-36 flex-1 m-l-10"
                                          field     = {gd.fields.timeReport.endMoment}
                                          model     = {props.model}
                                          onChange  = {onEndTimeChange}/>
                </div>
            </div>

        </>
    )
}



